export function muteAllMediaOnce(): void {
    const videos = document.querySelectorAll('video');
    const audios = document.querySelectorAll('audio');
  
    videos.forEach((video: HTMLVideoElement) => {
      video.muted = true;
      video.volume = 0;
    });
  
    audios.forEach((audio: HTMLAudioElement) => {
      audio.muted = true;
      audio.volume = 0;
    });
  }
  
